import { render, staticRenderFns } from "./BillingCockpit.vue?vue&type=template&id=18537e5d&scoped=true"
import script from "./BillingCockpit.vue?vue&type=script&lang=js"
export * from "./BillingCockpit.vue?vue&type=script&lang=js"
import style0 from "./BillingCockpit.vue?vue&type=style&index=0&id=18537e5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18537e5d",
  null
  
)

export default component.exports